<p #sectionContainer>spotlight-section works!</p>
